import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import React, { useState } from 'react';
import styled from 'styled-components';
import { alpha } from 'utils/ui/colors';
import Popover from 'components/Popover';
import Text from 'components/Text';
import VisuallyHidden from 'components/VisuallyHidden';
var ReadoutList = styled.ul.withConfig({
  displayName: "ChartTooltips__ReadoutList",
  componentId: "sc-1mr8f8e-0"
})(["position:absolute;top:0;left:0;bottom:0;display:flex;width:100%;margin:0;padding:4px 0px 4px ", "px;list-style-type:none;"], function (p) {
  return p.pl || 0;
});
var ReadoutListItem = styled.li.withConfig({
  displayName: "ChartTooltips__ReadoutListItem",
  componentId: "sc-1mr8f8e-1"
})(["position:relative;display:flex;justify-content:center;align-items:flex-end;flex:1;text-align:center;opacity:0;&:first-child,&:last-child{flex:0.5;}&:first-child{justify-content:flex-start;}&:last-child{justify-content:flex-end;}&:hover{opacity:1;}"]);
var Cursor = styled.span.withConfig({
  displayName: "ChartTooltips__Cursor",
  componentId: "sc-1mr8f8e-2"
})(["display:block;height:", "%;width:1px;background-color:", ";"], function (p) {
  return p.yValue * 100;
}, function (p) {
  return alpha(p.theme.shade, p.theme.lineStrength);
});
var TooltipLink = styled.a.withConfig({
  displayName: "ChartTooltips__TooltipLink",
  componentId: "sc-1mr8f8e-3"
})(["position:absolute;display:block;width:100%;height:100%;"]);
function getLabel(labels, index) {
  if (!(labels !== null && labels !== void 0 && labels.length)) return null;
  return labels[index] || labels[index % labels.length];
}
function getDefaultReadout(value, label, name) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Text, {
    bold: true,
    size: "m",
    lineHeight: 1
  }, label, /*#__PURE__*/React.createElement("br", null)), name ? "".concat(name, ": ").concat(value) : value);
}
function ChartTooltips(_ref) {
  var tooltipDistance = _ref.tooltipDistance,
    data = _ref.data,
    labels = _ref.labels,
    labelClicks = _ref.labelClicks,
    name = _ref.name,
    _ref$getTooltipReadou = _ref.getTooltipReadout,
    getTooltipReadout = _ref$getTooltipReadou === void 0 ? getDefaultReadout : _ref$getTooltipReadou,
    _ref$tooltipProps = _ref.tooltipProps,
    tooltipProps = _ref$tooltipProps === void 0 ? {
      variant: 'inverted',
      p: 'xs',
      fontSize: 's',
      as: 'div',
      ignorePointerEvents: true
    } : _ref$tooltipProps,
    _ref$pl = _ref.pl,
    pl = _ref$pl === void 0 ? 0 : _ref$pl;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredPoint = _useState2[0],
    setHoveredPoint = _useState2[1];
  if (!(data !== null && data !== void 0 && data.length)) return null;
  var maxValue = Math.max.apply(null, data);
  return /*#__PURE__*/React.createElement(ReadoutList, {
    pl: pl
  }, data.map(function (value, index) {
    var label = getLabel(labels, index);
    var labelLink = labelClicks === null || labelClicks === void 0 ? void 0 : labelClicks.at(index);
    var readOut = getTooltipReadout(value, label, name);

    // Apply a higher offset if the value is low to prevent overlap with x-axis
    var adjustedDistance = tooltipDistance || (value <= 10 ? 50 : 8);
    return /*#__PURE__*/React.createElement(ReadoutListItem, {
      key: index,
      onMouseEnter: function onMouseEnter() {
        return setHoveredPoint(index);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoveredPoint(null);
      }
    }, labelLink && /*#__PURE__*/React.createElement(TooltipLink, {
      onClick: labelLink
    }), /*#__PURE__*/React.createElement(Popover, _extends({}, tooltipProps, {
      isOpen: hoveredPoint === index,
      placement: "top",
      distance: adjustedDistance,
      content: readOut
    }), function (popover) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VisuallyHidden, null, readOut), /*#__PURE__*/React.createElement(Cursor, {
        ref: popover.ref,
        yValue: value / maxValue
      }));
    }));
  }));
}
export default ChartTooltips;